import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

/**
 * Petit badge qui affiche une variation `%` avec flèche +/- et couleur.
 *
 *  - `sens` : 'up' | 'down' | 'flat'  (calculé côté backend ou côté front).
 *  - `invert` : pour les KPIs où une baisse est positive (durée, coût…),
 *    on inverse simplement la couleur sans toucher au signe affiché.
 */
export interface DeltaBadgeProps {
  delta: number;
  sens: 'up' | 'down' | 'flat';
  invert?: boolean;
  className?: string;
}

export function DeltaBadge({ delta, sens, invert = false, className = '' }: DeltaBadgeProps) {
  let toneClass = 'bg-gray-100 text-gray-600';
  if (sens === 'up') {
    toneClass = invert ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700';
  } else if (sens === 'down') {
    toneClass = invert ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700';
  }

  const Icon = sens === 'up' ? ArrowUp : sens === 'down' ? ArrowDown : Minus;
  const sign = delta > 0 ? '+' : '';
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[11px] font-semibold ${toneClass} ${className}`}
    >
      <Icon className="w-3 h-3 mr-0.5" />
      {sign}
      {delta.toFixed(1)}%
    </span>
  );
}
